export default __webpack_public_path__ + "65b846008f0b5687d09494890ec135d5.png";